// extracted by mini-css-extract-plugin
export default {"content":"style_content__HOal3","footer":"style_footer__T70v+","delete":"style_delete__oZjCy","modal":"style_modal__5GmQt"};